import { Component, OnInit, Directive} from '@angular/core';
import { Meta, Title } from "@angular/platform-browser";

// declare jquery
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-case-studies',
  templateUrl: './case-studies.component.html',
  styleUrls: ['./case-studies.component.css']
})
export class CaseStudiesComponent implements OnInit {

  constructor(meta: Meta, title: Title) {

        title.setTitle('Sarsis | Case Studies');

            meta.addTags([
              { name: 'author',   content: 'sarsis.com'},
              { name: 'keywords', content: 'Enterprise Web Development, Web Development, E-commerce, Angular 2/4 Service, Single Page Application Development, C#, .NET, Javascript, HTML, CSS, Bootstrap 3/4'},
              { name: 'description', content: 'Enterprise Web Application Development Company located in San Diego' }
            ]);
       }

  ngOnInit() {
    // case study tab
    $("#rbbh").show();
  }

}
